"use strict";

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var utils = require("../../screeners/utils");

var scale = ["0", "1", "2", "3", "4", "5"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var fnUsefulnessScaleResp = function fnUsefulnessScaleResp(n) {
  return n;
};

var difficultyOptions = ["Overloaded with work", "Current project not engaging/interesting", "Lacking resources to do job", "Uncertainty if my job is secure", "Not paid enough for the work I do", "Frustrated with a colleague/colleagues", "Family issue", "Unfair/disrespectful treatment by management", "Bullying", "Not sure what's expected of me for task/role/project", "Not recognised enough for the work I do", "Lacking friendships/peer support network at work", "Lacking opportunities to work on what I like", "None of these options"];
var surveyscreeners = [utils.screeners.WHO5, utils.screeners.STRESS];
var questions = (0, _screeners.expandscreeners)([_utils.screeners.WHO5, {
  extraText: "In the past month,",
  batteryId: "WHO5",
  type: "multiSkip",
  meta: {
    answerLabel: "My challenges are...",
    skipLabel: "I have no challenges at work",
    responsePrefix: "My challenges are: ",
    noResponsePrefix: "I have no challenges at work"
  },
  prompt: "have any of the following <b>made it hard for you to work<br /> effectively</b> (you can choose multiple options)",
  options: difficultyOptions
}, _utils.screeners.STRESS, {
  prompt: "How would you rate the Uprise program overall?",
  extraText: "",
  type: "slider",
  options: scale,
  key: "npsUprise",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "PROGRESS"
}, {
  prompt: "How would you rate your experience with your Uprise coach?",
  extraText: "",
  type: "slider",
  options: scale,
  batteryId: "PROGRESS"
}, {
  prompt: "If we could change or improve anything about the program, what would it be?",
  extraText: "",
  meta: {
    answerLabel: "My feedback is..",
    summaryTitle: "Your action for Other was…",
    placeholder: ""
  },
  type: "textarea",
  optional: true,
  key: "magicWand",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "PROGRESS"
}]);

var analysis = function analysis(answers, bonus) {
  if (!answers) return null;
  var results = {};
  surveyscreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answers[screener], screener); // answer: {WHO5: Array, STRESS: Array}

    filteredQuestions.forEach(function (q, i) {
      if (!q.key) return;
      results[q.key] = q.eval(answers[screener][i]);
    });
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};